import React from 'react';
import { SparklineChart } from './SparklineChart';

interface PrimaryMetricCardProps {
  title: string;
  value: string | number;
  trend: string;
  data: any[];
}

export function PrimaryMetricCard({ title, value, trend, data }: PrimaryMetricCardProps) {
  return (
    <div
      className="rounded-3xl p-6 backdrop-blur-sm border"
      style={{
        backgroundColor: '#111116',
        borderColor: '#1e1e25',
      }}
    >
      <div className="mb-4">
        <p style={{ color: '#8a8a95' }} className="text-sm font-medium mb-2">
          {title}
        </p>
        <h3 style={{ color: '#f5f5f7' }} className="text-4xl font-bold">
          {value}
        </h3>
      </div>

      <div className="mb-4 h-12">
        <SparklineChart data={data} />
      </div>

      <div className="flex items-center justify-between">
        <span style={{ color: '#08d660' }} className="text-sm font-medium">
          {trend}
        </span>
      </div>
    </div>
  );
}
